import $ from 'jquery';
import defaultsDeep from 'lodash/defaultsDeep';
import invokeSmartScripts from './smart-script';
import Globalize from 'globalize';

const utils = {
    confirmAction: [],

    getFormAsJson: ($form, stringify) => {
        const data = $form.serializeArray().reduce((res, item) => {
            if (!(item.name in res)) {
                res[item.name] = item.value;
            }
            return res;
        },
        {});

        const unFlat = (obj) => {
            const nameDelim = '.';
            const multilevel = Object.keys(obj).filter((key) => key.indexOf(nameDelim) >= 0);

            const newKeys = [];
            for (let i = 0; i < multilevel.length; i++) {
                const itm = multilevel[i];
                const delimPos = itm.indexOf(nameDelim);
                const name = itm.substr(0, delimPos);
                if (!(name in obj)) {
                    obj[name] = {};
                    newKeys.push(name);
                }
                obj[name][itm.substr(delimPos + 1, itm.length)] = obj[itm];
                delete obj[itm];
            }
            newKeys.forEach((k) => {
                unFlat(obj[k]);
                makeArrays(obj[k]);
            });
        };

        // Convert item[0] to array


        const makeArrays = (data) => {
            const propertiesToDelete = [];
            const itemsToGroup = [];

            $.each(data,
                (key, value) => {
                    const regexp = /^([a-zA-Z0-9_]+)\[(\d+)\]/g;
                    const matches = regexp.exec(key);
                    if (!matches) {
                        return;
                    }
                    itemsToGroup.push({
                        arrayName: matches[1],
                        arrayIndex: matches[2],
                        value,
                    });
                    propertiesToDelete.push(key);
                });

            const arrays = itemsToGroup.reduce(function(rv, x) {
                (rv[x['arrayName']] = rv[x['arrayName']] || []).push(x);
                return rv;
            },
            {});
            $.each(arrays,
                (key, value) => {
                    const resultedArray = new Array(Math.max.apply(null, value.map((elt) => elt.arrayIndex)) + 1);
                    const radix = 10;
                    value.forEach((v) => {
                        resultedArray[parseInt(v.arrayIndex, radix)] = v.value;
                    });
                    data[key] = resultedArray;
                });

            propertiesToDelete.forEach((property) => delete data[property]);
        };

        unFlat(data);
        makeArrays(data);
        return stringify === true ? JSON.stringify(data) : data;
    },

    getHashLocation: () => {
        let hash = window.location.hash;

        // fixing facebook callback hash junk
        if (hash === '#_=_') {
            hash = '';
        }

        if (hash) {
            hash = hash.substr(1);
        }
        hash = decodeURI(hash);
        return hash;
    },

    getHashLocationObject: (templateObj) => { // templateObj is passed to restore null and false properties
        const hashLocation = utils.getHashLocation();
        if (hashLocation) {
            try {
                const obj = JSON.parse(hashLocation);
                return templateObj === null ? obj : defaultsDeep(obj, templateObj);
            } catch (e) {
                return null;
            }
        }

        return null;
    },

    updateHashLocation(obj) {
        const stringifyReplacer = (key, value) => { // stringifyReplacer removes null and false properties
            if (value !== null && value !== false) {
                return value;
            }
        };

        const newLocation = JSON.stringify(obj, stringifyReplacer);

        if (utils.getHashLocation() !== newLocation) {
            obj.uid = utils.genUid();
            history.replaceState(window.location.state, document.title, `#${encodeURI(JSON.stringify(obj, stringifyReplacer))}`);
        }
    },

    genUid: () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
            function(c) {
                const r = Math.random() * 16 | 0; const v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
    },

    random: (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    subscribeModalConfirm(actionSelectors, modalSelector) {
        if (!utils.confirmAction) {
            utils.confirmAction = [];
        }

        const modalItem = $(modalSelector);

        for (const selector of actionSelectors) {
            if (!utils.confirmAction[selector]) {
                utils.confirmAction[selector] = function(actionElement, onActionConfirmed) {
                    const confirmHandler = (e) => {
                        modalItem.find('.confirm-action').off('click').on('click',
                            () => {
                                if (onActionConfirmed) {
                                    onActionConfirmed(e.currentTarget);
                                }

                                modalItem.modal('hide');
                                // alert('hide')
                            });

                        modalItem.modal('show');
                        e.stopPropagation();
                        // alert('show')
                        return false;
                    };

                    $(actionElement).click(confirmHandler);
                };
            }
        }
    },

    subscribeModalClose(buttonCloseSelector, modalSelector) {
        $(buttonCloseSelector).click(function() {
            $(modalSelector).modal('hide');
        });
    },

    parseNumber(value) {
        if (value == null || value == 0) {
            return value;
        }

        let parsedValue = Globalize.parseNumber(value.toString(), {maximumFractionDigits: 2});

        if (isNaN(parsedValue)) {
            parsedValue = parseFloat(value.toString().replace(/[\s\xA0,]/g, ''));
        }

        return !isNaN(parsedValue) ? parsedValue : null;
    },

    formatNumber(value) {
        const parsedValue = utils.parseNumber(value);

        if (parsedValue != null) {
            return Globalize.formatNumber(parsedValue, {maximumFractionDigits: 2});
        }

        return null;
    },

    formatString(format, ...args) {
        const argArr = Array.from(args);
        return format.replace(/{(\d+)}/g, function(match, number) {
            return typeof argArr[number] != 'undefined' ?
                argArr[number] :
                match
            ;
        });
    },

    // todo: remove after rebrand, this logic should be in components
    formatNumberInput(target) {
        const input = $(target);
        input.val(utils.formatNumber(input.val()));

        if (input[0] && input[0].form) {
            input.valid();
        }
    },

    addInputRemainingCharactersCounter(inputSelector, labelText) {
        const input = $(inputSelector);
        if (input.length) {
            const maxLength = input.attr('maxLength') || input.data('val-length-max');
            const textRemaining = maxLength - input.val().length;

            if (maxLength) {
                const counter = $(`<div class="characters-counter">${textRemaining} ${labelText}</div>`);
                input.after(counter);

                $(inputSelector).keyup((e) => {
                    const textRemaining = maxLength - input.val().length;

                    if (textRemaining >= 0) {
                        counter.html(`${textRemaining} ${labelText}`);
                    } else {
                        counter.html(`0 ${labelText}`);
                        input.val(input.val().substring(0, maxLength));
                    }
                });
            }
        }
    },

    focusOnAnchor(anchor) {
        const scrollTimeoutInMillis = 1000;
        const scrollEasingFunction = 'swing';
        const focusingClass = 'focused';

        if (!anchor) {
            const parsedHash = this.getHashLocationObject();
            if (parsedHash) {
                anchor = parsedHash.scrollAnchor;
            }
        }

        if (anchor) {
            const anchorId = `#${anchor}`;
            $(document).ready(function() {
                focusOnAnchorAnimation($(anchorId));
            });
        }

        function focusOnAnchorAnimation(anchorElem) {
            $('html').animate(
                {scrollTop: getScrollPositionForElement(anchorElem)},
                scrollTimeoutInMillis,
                scrollEasingFunction,
                function() {
                    highlightElement(anchorElem);
                },
            );
        }

        function getScrollPositionForElement(element) {
            return element.offset().top - getScrollingGapBeforeElement(element);
        }

        function getScrollingGapBeforeElement(element) {
            return (window.innerHeight - element.height()) / 2;
        }

        function highlightElement(element) {
            element.addClass(focusingClass);
        }
    },

    addConversationAction(actionType, actionFunc) {
        if (!window.conversationActions) {
            window.conversationActions = {};
        }

        window.conversationActions[actionType] = actionFunc;
    },

    doConversationAction(actionType, conv, param) {
        if (window.conversationActions && window.conversationActions[actionType]) {
            window.conversationActions[actionType](conv, param);
        }
    },

    showModal(modalSelector, html, modalBodySelector, modalCloseSelector, onPreviewClosed) {
        const modalContainer = $(modalSelector);
        const bodyContainer = modalContainer.find(modalBodySelector || '.modal-body')[0];

        utils.insertMarkupWithScripts(bodyContainer, html);
        modalContainer.modal('show');
        modalContainer
            .off('hidden.bs.modal')
            .on('hidden.bs.modal', function(e) {
                if ($.isFunction(onPreviewClosed)) {
                    onPreviewClosed();
                }
                e.stopPropagation();
            });

        setTimeout(() => {
            $(window).trigger('resize');
        }, 100);

        modalContainer.find(modalCloseSelector || '.close')
            .off('click')
            .on('click', (e) => {
                modalContainer.modal('hide');
                e.stopPropagation();
            });
    },

    checkOpenHoursValue: (value) => typeof value === 'object' && value !== null &&
        typeof value.advanced === 'boolean' &&
        value.advancedText !== undefined &&
        ['daysOfWeek', 'interval'].every((key) => typeof value[key] === 'object' && value[key] !== null) &&
        ['from', 'to'].every((key) => typeof value.interval[key] === 'object' && value.interval[key] !== null) &&
        ['from', 'to'].every(
            (keyEx) => ['hours', 'minutes'].every((keyIn) => typeof value.interval[keyEx][keyIn] ===
                'number')),

    isObjectEmpty: (obj) => Object.keys(obj).length === 0 && obj.constructor === Object,

    insertMarkupWithScripts: (element, html) => {
        element.innerHTML = html;
        invokeSmartScripts(element);
    },

    isNumber: (value) => !value.match(/^\s*$/) && !isNaN(value),

    // TODO: implement good solution for russian word forms
    // The same method exists in C# code
    changeWordForm(word) {
        if (!word) {
            return word;
        }

        switch (word) {
        // Warn: keep this code the same in c# and js, use copy/paste when change
        case 'Квартира': return 'Квартиру';
        case 'Дача': return 'Дачу';
        case 'Торговая площадь': return 'Торговую площадь';
        case 'Комната': return 'Комнату';
        case 'Москва': return 'в Москве';
        case 'Санкт-Петербург': return 'в Санкт-Петербурге';
        case 'Екатеринбург': return 'в Екатеринбурге';
        case 'Новосибирск': return 'в Новосибирске';
        case 'Нижний Новгород': return 'в Нижнем Новгороде';
        case 'Уфа': return 'в Уфе';
        case 'Казани': return 'в Казани';
        case 'Минск': return 'в Минске';
        case 'Брест': return 'в Бресте';
        case 'Витебск': return 'в Витебске';
        case 'Гомель': return 'в Гомеле';
        case 'Гродно': return 'в Гродно';
        case 'Могилев': return 'в Могилеве';
        case 'Бобруйск': return 'в Бобруйске';
        case 'Нью Йорк': return 'в Нью Йорке';
        case 'Лос Анджелес': return 'в Лос Анджелесе';
        case 'Чикаго': return 'в Чикаго';
        case 'Вашингтон': return 'в Вашингтоне';
        case 'Хьюстон': return 'в Хьюстоне';
        case 'Сан-Франциско': return 'в Сан-Франциско';
        case 'Сиэтл': return 'в Сиэтле';
        }

        return word;
    },

    changeToPlural(word) {
        if (!word) {
            return word;
        }

        switch (word) {
        case 'Apartment': return 'Apartments';
        case 'Unit': return 'Units';
        case 'Townhouse': return 'Townhouses';
        case 'House': return 'Houses';
        case 'Land only': return 'Lands only';
        case 'Room': return 'Rooms';
        case 'Lifestyle property': return 'Lifestyle properties';
        case 'Квартира': return 'Квартиры';
        case 'Часть дома': return 'Части дома';
        case 'Таунхаус': return 'Таунхаусы';
        case 'Дом': return 'Дома';
        case 'Участок': return 'Участки';
        case 'Комната': return 'Комнаты';
        case 'Дача': return 'Дачи';
        }

        return word;
    },

    sendPostRequest(url, obj) {
        return $.ajax({
            type: 'POST',
            url,
            contentType: 'application/json',
            data: JSON.stringify(obj),
        });
    },

    getCurrentUrl() {
        return `${location.pathname}${location.search}${location.hash}`;
    },
    lowerFirstLetter(str) {
        if (!str || !str.length) {
            return str;
        }

        return str[0].toLowerCase() + str.slice(1);
    },
    capitalizeFirstLetter(str) {
        if (!str || !str.length) {
            return str;
        }

        return str[0].toUpperCase() + str.slice(1);
    },
    isFullVisibilityExpected(el, considerSize) {
        if (!el) {
            return false;
        }

        try {
            if (this.isElementHidden(el)) {
                return false;
            }

            const rect = el.getBoundingClientRect();

            return ((rect.width > 0 && rect.height > 0) || !considerSize) &&
                this.areBordersInViewport(rect);
        } catch (error) {
            console.error(error);
            return false;
        }
    },

    areBordersInViewport(rect) {
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth));
    },

    isElementHidden(el) {
        if (!el || el.nodeType != Node.ELEMENT_NODE) {
            return true;
        }

        const styles = window.getComputedStyle(el);

        if (styles.getPropertyValue('opacity') == 0 ||
            styles.getPropertyValue('display') == 'none' ||
            styles.getPropertyValue('visibility') == 'hidden') {
            return true;
        }

        return false;
    },

    getLabelByCount(count, labelSingle, labelLessThanFive, labelMoreThanFive) {
        const lastDigit = count % 10;
        const twoLastDigints = count % 100;

        return lastDigit === 1 && twoLastDigints !== 11 ?
            labelSingle :
            lastDigit > 1 && lastDigit < 5 && (twoLastDigints < 10 || twoLastDigints >= 20) ?
                labelLessThanFive :
                labelMoreThanFive;
    },

    createRequestConfig(antiforgeryToken) {
        const requestConfig = {
            headers: {
                RequestVerificationToken: antiforgeryToken,
            },
        };
        return requestConfig;
    },

    createFormRequestConfig(antiforgeryToken) {
        const requestConfig = {
            headers: {
                'RequestVerificationToken': antiforgeryToken,
                'Content-Type': 'multipart/form-data',
            },
        };
        return requestConfig;
    },

    addQueryParam(key, value) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.append(key, value);
        url.search = params.toString();
        return url.href;
    },

    addQueryParamForUrl(incomeUrl, key, value) {
        const urlContainsParams = incomeUrl.includes('?');
        const initialUrl = urlContainsParams ? incomeUrl : `${incomeUrl}?`;
        const urlParts = initialUrl.split('?');
        const params = new URLSearchParams(urlParts[1]);
        params.append(key, value);
        return `${urlParts[0]}?${params.toString()}`;
    },

    containAnyLetters(testString) {
        const regExp = /[a-zA-Z]/g;
        return regExp.test(testString);
    },

    containsOnlyDigits(testString) {
        const regexp = new RegExp(`^\\d{${testString.length}}`);
        return regexp.test(testString);
    },

    // can be use with async
    sleep(delayInMilliseconds) {
        return new Promise((resolve) => setTimeout(resolve, delayInMilliseconds));
    },
};

export default utils;
